
import React from 'react';
import Header from '../components/Header.jsx';
import Breadcrumb from '../components/Breadcrumb.jsx';
import Container from '../components/Container.jsx';

export function DefaultLayout({ children, className = '' }) {
  return (
    <div className={`min-h-screen bg-background text-text-primary ${className}`}>
      <Header />
      <div className="flex flex-col min-h-screen pt-20"> {/* pt-20 for header space */}
        <Container>
          <Breadcrumb className="py-4" />
        </Container>
        {children}
      </div>
    </div>
  );
}

export default DefaultLayout;
